// extracted by mini-css-extract-plugin
export default {"main":"b6afbe6950","tit":"b3ff15793b","maintitle":"e33d45c2b4","ylw":"a66e921ed1","white":"_52366778d2","mv_title":"ab97bfe7c0","mv_nc":"_2a3fba8d7f","mv_in":"_5c604f5484"};